export default "__VITE_ASSET__WjbAanp5__"